<template>
  <v-row align="start" justify="center" class="ma-0 px-8">
    <v-col cols="12">
      <v-row align="center" justify="center" class="ma-0">
        <v-btn fab large light depressed class="py-8" exact :to="{name: 'Home'}"><v-icon x-large>mdi-close</v-icon></v-btn>
      </v-row>
    </v-col>
    <transition mode="out-in">
      <v-col cols="auto" :style="{width: '100%', maxWidth: '140vh'}" v-if="videoID" key="loaded">
        <v-responsive :aspect-ratio="16/9" >
          <iframe v-if="videoService === 'youtube' || (videoService === 'vimeo' && hasValidSpentTicket)" width="100%" height="100%" :src="iframeURL" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <v-row class="fill-height blue lighten-1 pa-16" align="center" justify="center" v-else-if="videoService === 'vimeo' && !hasValidSpentTicket" >
            <mail-ticket-form class="col col-12"  />
          </v-row>
        </v-responsive>
      </v-col>
      <v-col cols="auto" v-else key="loading">
        <v-progress-circular indeterminate  />
      </v-col>
    </transition>
  </v-row>
</template>
<script>
import getVideoId from 'get-video-id'
import GetTalk from '@/graphql/GetTalk.gql'
import GetPastTalk from '@/graphql/GetPastTalk.gql'
import findIndex from 'lodash/findIndex'
import MailTicketForm from '@/organisms/MailTicketForm.vue'
import { userHasRequestedACL, EDITOR_ACL } from '@/services/AuthLevel'

export default {
  name: 'RecordingPage',
  components: {
    MailTicketForm

  },
  props: {
    type: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    hasValidSpentTicket () {
      if (userHasRequestedACL(this.$root.auth.loggedUser, EDITOR_ACL)) {
        return true
      }
      return this.$root.databaseUser &&
        this.$root.databaseUser.spentTickets &&
        Array.isArray(this.$root.databaseUser.spentTickets) &&
        findIndex(this.$root.databaseUser.spentTickets, (t) => t.indexOf('E931') === 0) !== -1
    },
    videoService () {
      if (this.Talk && this.type === 'Talk') {
        return getVideoId(this.Talk.recordingYoutubeURL || this.Talk.recordingVimeoURL).service
      } else if (this.PastTalk && this.type === 'PastTalk') {
        return getVideoId(this.PastTalk.recordingYoutubeURL || this.PastTalk.recordingVimeoURL).service
      }
      return null
    },
    videoID () {
      if (this.Talk && this.type === 'Talk') {
        return getVideoId(this.Talk.recordingYoutubeURL || this.Talk.recordingVimeoURL).id
      } else if (this.PastTalk && this.type === 'PastTalk') {
        return getVideoId(this.PastTalk.recordingYoutubeURL || this.PastTalk.recordingVimeoURL).id
      }
      return null
    },
    iframeURL () {
      if (this.videoService === 'youtube') {
        return `https://www.youtube.com/embed/${this.videoID}?autoplay=1&modestbranding=1&showinfo=0&autohide=1&rel=0`
      } else if (this.videoService === 'vimeo') {
        return this.Talk.recordingVimeoURL
      }
      return null
    }
  },
  apollo: {
    Talk: {
      query: GetTalk,
      skip () {
        return this.type !== 'Talk'
      },
      variables () {
        return {
          status: 'PUBLISHED',
          slug: this.slug
        }
      }
    },
    PastTalk: {
      query: GetPastTalk,
      skip () {
        return this.type !== 'PastTalk'
      },
      variables () {
        return {
          status: 'PUBLISHED',
          slug: this.slug
        }
      }
    }
  }
}
</script>
